import { useQuery } from '@tanstack/react-query';
import { getCustomerDetails } from 'api/shopifyV2/customer';
import { ShopifyCustomer } from 'api/shopifyV2/types';
import { StoreCode } from 'schema/storeCode';

interface UseCustomerResult {
  customer: ShopifyCustomer | null;
}

export const useCustomerDetails = (
  storeCode: StoreCode,
  customerAccessToken?: string
): UseCustomerResult => {
  const queryKey = ['customerDetails', storeCode, customerAccessToken];

  const queryFn = async () => {
    if (!customerAccessToken) {
      throw new Error('No customer access token provided');
    }

    const customerData = await getCustomerDetails(storeCode, customerAccessToken);
    if (!customerData || !customerData.customer) {
      throw new Error('No customer data returned');
    }

    return customerData.customer;
  };

  const { data } = useQuery<ShopifyCustomer, Error>({
    queryKey,
    queryFn,
    enabled: !!customerAccessToken
  });

  return {
    customer: data || null
  };
};
